<template>
  <div v-loading="loading" class="order-detail-container">
    <div class="buttonbc">
      <!--      <el-button @click="() => { $router.go(0); }" size="small" type="primary" >刷新</el-button>-->
      <el-button @click="() => { $router.go(-1); }" size="small" class="back_btn">
        <img src="../../../assets/back.png" alt="">
      </el-button>
    </div>
    <div class="cont">
      <br />
      <br />
      <h4>基本信息</h4>
      <table class="table-cont">
        <tbody>
          <tr>
            <td class="details-div-span">
              交易状态：
              <span class="detail-span1">{{ orderDetail.order_status_text }}</span>
            </td>
          </tr>
          <tr>
            <td>订单信息：</td>
          </tr>
          <tr class="detail-tr1">
            <td v-if="orderDetail.enterprise_id !== orderDetail.seller_id">平台支付金额：
              <span
                v-if="orderDetail.order_source == 5 || orderDetail.order_sku_list[0].shop_id == orderDetail.order_sku_list[0].seller_id && orderDetail.delivery_method == 1">——</span>
              <span v-else>{{ orderDetail.supplier_order_price | unitPrice("¥") }}</span>
            </td>
            <td>平台支付时间：
              <span
                v-if="orderDetail.order_source == 5 || orderDetail.order_sku_list[0].shop_id == orderDetail.order_sku_list[0].seller_id && orderDetail.delivery_method == 1">——</span>
              <span v-else>{{ orderDetail.create_time | unixToDate }}</span>
            </td>
          </tr>
          <tr>
            <td>{{ orderDetail.delivery_method == 1 ? '收货人信息：' : '领取人信息：' }}</td>
          </tr>
          <tr class="detail-tr1">
            <td>{{ orderDetail.delivery_method == 1 ? '收货人：' : '领取人：' }}{{ orderDetail.ship_name }}</td>
            <td>{{ orderDetail.delivery_method == 1 ? '收货人手机号：' : '领取人手机号：' }}{{ orderDetail.ship_mobile }}</td>
          </tr>
          <tr class="detail-tr1" v-if="orderDetail.delivery_method == 1">
            <td>
              收货地址：
              {{ orderDetail.ship_province }}{{ orderDetail.ship_city }}
              {{ orderDetail.ship_county }}{{ orderDetail.ship_town ? orderDetail.ship_town : '' }}
              {{ orderDetail.ship_addr }}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <h4>商品信息</h4>
      <template>
        <el-table :data="productList" :header-cell-style="{ background: '#cccccc' }" :expand-row-keys="rowKeysList"
          row-key="sku_sn">
          <el-table-column prop="goods_image" label="商品详情" width="300">
            <template slot-scope="scope">
              <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">
                <img :src="scope.row.goods_image" class="goods-image" />
                <el-tooltip class="item" effect="light" :content="scope.row.name" placement="top">
                  <el-button style="max-width: 19vw; overflow: hidden; text-overflow: ellipsis;" class="shop-name"
                    type="text">{{ scope.row.name }}</el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="数量"></el-table-column>
          <el-table-column prop="price" label="平台售价">
            <template slot-scope="scope">{{
              scope.row.platform_price / scope.row.num | unitPrice("￥")
            }}</template>
          </el-table-column>
          <el-table-column prop="shop_price" label="企业售价">
            <template slot-scope="scope">{{ scope.row.enterprise_purchase_price | unitPrice("￥") }}</template>
          </el-table-column>
          <el-table-column prop="enterprise_price" label="站点售价">
            <template slot-scope="scope">
              {{ scope.row.shop_purchase_price | unitPrice("￥") }}
            </template>
          </el-table-column>

          <!-- 自提订单开始 -->
          <template v-if="[2, 3].includes(orderDetail.delivery_method)">
            <el-table-column min-width="120" label="核销码" prop="verify_code" />
            <el-table-column min-width="120" label="核销状态">
              <template slot-scope="scope">
                <span>{{ ['', '未核销', '已核销', '已过期'][scope.row.verify_status] }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="220" label="自提地址">
              <template slot-scope="scope">
                <span>{{ scope.row.selected_pickup_station_add }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="220" label="自提日期">
              <template slot-scope="scope">
                <span>{{ timeFilter(scope.row.pickup_time, 'datatime') }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="120" label="自提时间">
              <template slot-scope="scope">
                <span>{{ timeFilter(scope.row.pickup_time, 'time') }}</span>
              </template>
            </el-table-column>
          </template>
          <!-- 自提订单结束 -->

          <el-table-column v-if="orderDetail.delivery_method == 1" prop="shop_total_price" label="物流状态">
            <template slot-scope="{row}">
              <span v-if="row.logistics_status_text">{{ row.logistics_status_text }}</span>
              <span v-else>{{ row.state == 0 ? '未发货' : (row.state == 2 ? '已发货' : '已收货') }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="orderDetail.delivery_method == 1" prop="shop_total_price" label="维权状态">
            <template slot-scope="scope">
              {{ fService_status(scope.row.service_status) }}
            </template>
          </el-table-column>
          <!-- 蛋糕订单开始 -->
          <template
            v-if="productList.some(item => item.uncle_cake_shop_name) && [5].includes(orderDetail.delivery_method)">
            <el-table-column label="核销码" width="130">
              <template slot-scope="scope">
                <!-- 代付款、已取消 核销码字段展示空 -->
                <span v-if="!['WAIT_PAY', 'CANCELLED'].includes(orderDetail.order_status)">{{ scope.row.verify_code
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="自提门店" width="200" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.uncle_cake_shop_name + '—' + scope.row.uncle_cake_shop_address }}</span>
              </template>
            </el-table-column>
            <el-table-column label="自提时间" width="200" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.uncle_cake_ship_date + ' ' + scope.row.uncle_cake_ship_time_text }}</span>
              </template>
            </el-table-column>
          </template>
          <!-- 蛋糕订单结束 -->
        </el-table>
      </template>
      <br />
      <h4 v-if="orderDetail.delivery_method == 1">包裹信息</h4>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane v-for="(item, index) in expressInfo" :key="index" :label="item.message" :name="item.index">
          <template v-if="orderDetail.delivery_method == 4">
            <p style="background-color: #6666; height: 30px; line-height: 30px;">
              <span>以下商品由商家配送</span>
            </p>
            <div style="display: flex;">
              <div v-for="(i, index) in item.images" :key="index"
                style="width: 100px; height: 100px; margin-right: 20px;">
                <img :src="i" style="width: 100%; height: 100%;">
              </div>
            </div>
            <h3>配送信息：</h3>
            <span>配送人：{{ productList[0].uncle_cake_express_name }}</span><br />
            <span>配送人手机号：{{ productList[0].uncle_cake_express_mobile }}</span><br />
            <span>预计送达时间：{{ productList[0].uncle_cake_ship_date + ' ' + productList[0].uncle_cake_ship_time_text
            }}</span><br />
          </template>
          <template v-else>
            <p style="background-color: #6666; height: 30px; line-height: 30px;">
              <span>快递公司: {{ item.deliver_name }}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>物流单号: {{ item.delivery_no }}</span>
            </p>
            <div style="display: flex;">
              <div v-for="(i, index) in item.images" :key="index"
                style="width: 100px; height: 100px; margin-right: 20px;">
                <img :src="i" style="width: 100%; height: 100%;">
              </div>
            </div>
            <div class="logistics-info" v-if="item.data.msg === 'JD'">
              <p v-if="!item.data.data.orderTrack" style="display:block; line-height: 20px;">{{
                item.data.data[0].express.message }}</p>
              <ul v-else>
                <li v-for="(ship, index) in item.data.data.orderTrack" :key="index" class="ship-item">
                  <i class="ship-dot"></i>
                  <div class="ship-msg">
                    <p class="ship-msg-text">{{ ship.content }}</p>
                    <p class="ship-msg-time">{{ ship.msgTime }}</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="logistics-info" v-else>
              <p v-if="!item.data.data[0].express.data" style="display:block; line-height: 20px;">
                <!-- 判断物流是否超过三个月 expired==1（超过三个月） -->
                <span v-if="item.expired == 1">商家已发货，由于时间过长，已无法为您提供快递的物流信息</span>
                <span v-else>抱歉，暂时没有查到相关物流信息，请耐心等待。</span>
                <!-- {{item.data.data[0].express.message|| item.data.data[0].express }} -->
              </p>
              <ul v-else>
                <li v-for="(ship, index) in item.data.data[0].express.data" :key="index" class="ship-item">
                  <i class="ship-dot"></i>
                  <div class="ship-msg">
                    <p class="ship-msg-text">{{ ship.context }}</p>
                    <p class="ship-msg-time">{{ ship.time }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as API_order from "@/api/order";
import * as Foundation from "@/../ui-utils/Foundation";
export default {
  name: "orderDetail",
  computed: {
    ...mapGetters(["shopInfo"])
  },
  data () {
    return {
      rowKeysList: [],
      /** 列表loading状态 */
      loading: false,
      /** 订单详情数据 */
      orderDetail: {},
      productList: [],
      /*  订单编号 */
      sn: "",
      route: "",
      activeName: '1',
      /** 物流信息 */
      expressInfo: [],
    };
  },
  filters: {
    paymentTypeFilter (val) {
      return val === "ONLINE" ? "在线支付" : "线下支付";
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.sn = to.params.sn;
    this.GET_OrderDetail();
    next();
  },
  mounted () {
    this.sn = this.$route.params.sn;
    this.GET_OrderDetail();
    // this.getExpressInfo()
    this.route = this.$route.path.split("/")[2];
  },
  activated () {
    this.sn = this.$route.params.sn;
    this.GET_OrderDetail();
  },
  methods: {
    fService_status (status) {
      switch (status) {
        case "NOT_APPLY":
          return "未申请";
        case "APPLY":
          return "已申请";
        case "PASS":
          return "审核通过";
        case "REFUSE":
          return "审核未通过";
        case "EXPIRED":
          return "已失效或不允许申请售后";
        case "REFUNDFAIL":
          return "退款失败";
        case "COMPLETED":
          return "完成";
        case "WAIT_SEND_BACK":
          return "待寄回";
        case "SEND_BACK":
          return "买家寄回";
        case "SELLER_SHIP":
          return "卖家发货";
        case "REFUSE_SHIP":
          return "卖家拒绝发货";
        default:
          return "";
      }
    },
    /** 获取订单详情信息 */
    GET_OrderDetail () {
      this.loading = true;
      API_order.getOrderDetail(this.sn).then(res => {
        // 订单信息
        this.orderDetail = res;
        let cost_price = 0
        this.orderDetail.order_sku_list.forEach(item => {
          cost_price += item.cost_price
        })
        this.orderDetail['cost_price'] = cost_price
        this.productList = this.orderDetail.order_sku_list;
        this.productList.forEach(item => {
          if (!item.state) {
            item.state = 0
          }
        })
      }).then(() => {
        const jl = !!Number(this.$route.query.jl)
        if (jl) {
          API_order.getJinliLogistics({ jd_order_id: this.orderDetail.ext_order_no }).then(res => {
            this.loading = false;
            this.expressInfo = [{ deliver_name: '京东快递', data: { code: 1, msg: 'JD', data: res } }]
            this.expressInfo.forEach((item, index) => {
              item['message'] = '包裹' + String(index + 1)
              item['index'] = String(index + 1)
            })
            console.log(this.expressInfo)
          });
        } else {
          let params = {}
          params['order_sn'] = this.sn
          params['sku_sn'] = this.productList[0]['sku_sn']
          API_order.getLogistics(params).then(res => {
            this.loading = false;
            try {
              if (res[0].data.data[0].express.data[0].statusCode == "2") res[0].data.data[0].express.data.unshift({ context: "快件存在疑难" });
            } catch (error) {

            }
            this.expressInfo = res
            this.expressInfo.forEach((item, index) => {
              item['message'] = '包裹' + String(index + 1)
              item['index'] = String(index + 1)
            })
            console.log(this.expressInfo)
          });
        }

      })
    },
    getExpressInfo () {
      let params = {}
      params['order_sn'] = this.sn
      params['sku_sn'] = this.productList[0]['sku_sn']
      API_order.getLogistics(params).then(res => {
        this.expressInfo = res
        this.expressInfo.forEach((item, index) => {
          item['message'] = '包裹' + String(index + 1)
          item['index'] = String(index + 1)
        })
        console.log(this.expressInfo)
      });
    },
    /**格式化时间函数 */
    timeFilter (data, type) {
      const time = JSON.parse(data)
      let start = time.starting_date
      let end = time.ending_date
      let formateDate
      if (type == 'time') {
        formateDate = time.time_slot.split('_')
        formateDate = formateDate[0] + '~' + formateDate[1]
      } else {
        formateDate = Foundation.unixToDate(start, 'yyyy-MM-dd') + '~' + Foundation.unixToDate(end, 'yyyy-MM-dd')
      }
      return formateDate
    },
  }
};
</script>

<style lang="scss" scoped>
.logistics-info {
  background-color: #fff;
  padding: 10px 10px 50px 10px;

  // text-align: center;
  .ship-item {
    position: relative;
    display: flex;
    flex-wrap: wrap;

    &:first-child {
      .ship-dot {
        background-color: #ec3a33;
      }

      p {
        color: #ec3a33;
      }
    }

    &:not(:last-child)::after {
      content: "";
      position: absolute;
      z-index: 1;
      pointer-events: none;
      background-color: #e5e5e5;
      width: 1px;
      top: 37px;
      left: 10px;
      bottom: -20px;
    }
  }

  .ship-dot {
    position: relative;
    line-height: 20px;
    font-size: 10px;
    text-align: center;
    color: #666;
    margin: 24px 15px 0 5px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ccc;
  }

  .ship-msg {
    flex: 1;
    padding: 15px 0;
  }

  .ship-msg-text {
    color: #333;
    font-size: 14px;
    line-height: 18px;
  }

  .ship-msg-time {
    font-size: 12px;
    color: #999;
  }
}

.table-cont {
  margin-bottom: 0;
  font-size: 13px;
  width: 100%;
  max-width: 100%;

  .detail-tr1 {
    font-size: 12px;
    color: #a6a6a6;
  }
}

.table-cont.order-table td {
  border-top: 0;
}

.table-cont>tbody>tr>td {
  line-height: 1.42857;
  padding: 8px;
  vertical-align: middle;
}

.m-l-md {
  margin-left: 20px !important;
}

.order-detail-container {
  background: #fff;
  position: relative;
  padding: 20px;
  border-radius: 5px;
}

.buttonbc {
  float: right;
  height: 40px;

  .back_btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #1A43A9;

    img {
      width: 10px;
      height: 20px;
      position: relative;
      top: -2px;
      left: -4px;
    }
  }
}

.cont {
  /* width: 1400px; */
  /* margin-left: 80px; */
  margin-left: 30px;
  padding-bottom: 20px;
}

::v-deep .is-leaf {
  /* border: 1px solid #000000 !important; */
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
}

::v-deep .el-table__row td {
  /* border: 1px solid #000000 !important; */
  text-align: center;
  font-size: 16px;
}

// ::v-deep .el-table--border {
//   /* border: 1px solid #000000 !important; */
// }
.zongji {
  width: 100%;
  font-size: 26px;
  text-align: right;
  padding-top: 30px;
}

.sendhuo {
  margin-top: 60px;
  float: right;
}

.goods-image {
  width: 50px;
  height: 50px;
}
</style>
